import { Routes } from "@angular/router";
import { NotFoundComponent } from "../shared/components/not-found/not-found.component";

export function getFallBackRoutes(): Routes {
  return [
    {
      path: "**",
      component: NotFoundComponent,
    },
  ];
}
